/**
 * Client identity — the current signed-in user id, held in module scope so
 * non-React code (error boundaries, the reportError helper) can attach it to
 * diagnostics without prop-drilling or importing React context.
 *
 * Set from AppShell's signed-in user effect; cleared on sign-out. Mirrors the
 * accessor pattern used for selectedTaskId in socketService.
 */

let currentUserId: string | undefined;

export const setCurrentUserId = (id?: string): void => {
  currentUserId = id;
};

export const getCurrentUserId = (): string | undefined => currentUserId;
